
const initialState = {
    loggedIn: false,
    isTasksLoading: false,
    tasks: [],
    taskPaginationData: {},
    lastUser: null,
    loggedOutMessage: null
};

export default function auth(state = initialState, action = {}) {
    switch (action.type) {
        case 'AUTH_USER_TASKS_LOAD':
            return {
                ...state,
                isTasksLoading: true
            };
        case 'AUTH_USER_TASKS_LOAD_SUCCESS':
            // TODO: concat when paginating, replace when not
            return {
                ...state,
                isTasksLoading: false,
                tasks: action.result.events,
                taskPaginationData: action.result.paginationData
            };
        case 'LOGIN':
            return {
                ...state,
                lastUser: action.user,
                user: action.user,
                token: action.token,
                loggedOutMessage: null
            };
        case 'CLEAR_LOGGED_OUT_MESSAGE':
            return {
                ...state,
                loggedOutMessage: null
            };
        case 'LOGOUT':
            return {
                loggedOutMessage: action.loggedOutMessage,
                lastUser: state.lastUser,
                loggedIn: false,
                user: null,
                token: null
            };
        case 'LOAD_LAST_USER_FROM_LOCAL_STORAGE':
            return {
                ...state,
                lastUser: action.lastUser
            };
        case 'SCHEDULE_MARKED_COMPLETE_SUCCESS':
            var scheduleId = action.result.scheduleMarkedAsCompletedId;
            var tasks = state.tasks.filter(t => t.scheduleId != scheduleId);
            return {...state, tasks};
        case 'RECORD_PHONE_CALL_COMPLETE_SUCCESS':
            return {
                ...state,
                tasks: state.tasks.filter(t => t.id != action.result.id)
            };
        case 'LOAD_AUTH_FROM_LOCAL_STORAGE':
            var user = action.user;

            return {
                ...state,
                loggedIn: true,
                lastUser: action.user,
                user: {...user, isFg: user.organisationName == 'Fergus'},
                token: action.token
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./app/auth/reducer.js